import { useCallback, useEffect } from 'react';
import { ImportSharedView } from '@/entities/ShareView';
import { Analytics } from '@/shared/lib';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { useViewInitializationStateMachineContext } from '@/shared/ui';
import { updateChart, selectMetaIsLoaded } from '../../model/slice';
import type { CalendarChartState } from '../../model/types';
import { dataConfigValidator } from '../../model/types';

export function ImportSharedViewDialog() {
  const dispatch = useAppDispatch();
  const isColumnsMetaLoaded = useAppSelector(selectMetaIsLoaded);
  const { onNavigatedViewDetect, onNavigatedViewApply, onNavigatedViewError } =
    useViewInitializationStateMachineContext();

  useEffect(() => {
    onNavigatedViewDetect();
  }, [onNavigatedViewDetect]);

  const handleApplyView = useCallback(
    (view: unknown) => {
      onNavigatedViewApply();
      dispatch(updateChart(view as CalendarChartState));
      Analytics.sendFeatureUsage('share_view', 'apply');
    },
    [dispatch, onNavigatedViewApply],
  );
  const isViewValid = useCallback((view: unknown) => {
    const parseResult = dataConfigValidator.safeParse(view);

    return parseResult.success;
  }, []);

  if (!isColumnsMetaLoaded) {
    return null;
  }

  return (
    <ImportSharedView
      isViewValid={isViewValid}
      applyView={handleApplyView}
      onViewError={onNavigatedViewError}
    />
  );
}
